import React, {useMemo} from "react"
import {makeStyles} from "@material-ui/core/styles"
import Loading from "../../assets/images/loading.svg"

const useStyles = makeStyles(() => ({
  root: {
    textAlign: `center`,
  },
}))

export default function LoadingAnimation({width = 150}) {
  const classes = useStyles()
  return useMemo(
    () => (
      <div className={classes.root}>
        <Loading width={width} />
      </div>
    ),
    [classes],
  )
}
